/** Students who may take every practice and module exam without finishing every lecture. */
const ALL_EXAMS_EMAILS = new Set(['fasih1234@gmail.com']);

export function hasAllExamsUnlocked(email) {
  return ALL_EXAMS_EMAILS.has(String(email || '').trim().toLowerCase());
}
